import {
  download,
  GetLocalStorage,
  getUserId,
  isResponseCodeSuccess,
} from '../../tools/util'
import { useEffect, useReducer } from 'react'
import { history, useTypedSelector } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { setModuleDataAction } from '../../modules/pagecache'
import { userRouter } from '../../route'
import { GET_TASKLIST } from '../../api/TaskApi'
import { usePageCache } from '../../tools/utilHooks'
import reducer, {
  defaultState,
  taskcenterState,
  reloadStateAction,
  setDataSourceAction,
  setDataSourceLoadingAction,
  setPagesAction,
} from './reducer'

const useTaskCenterHook = () => {
  const [state, dispatch] = useReducer(reducer, defaultState)
  const { dataSource, pages, dataSourceLoading } = state
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const supRoute = userRouter[1].url
  const dispatchRedux = useDispatch()
  const { closeCurrentTab } = usePageCache()

  useEffect(() => {
    const flag = getpagecache()
    if (flag) {
      dispatch(reloadStateAction(flag))
      // 获取缓存的数据后以缓存的页数数据为入参 再次调用接口获取最新数据
      onRefresh(flag)
    } else {
      getdata(state)
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: state,
    })
    dispatchRedux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 获取列表数据
  const getdata = async (taskcenter: taskcenterState) => {
    // 在saga处理中 获取state
    const params = { ...taskcenter.pages }
    // 添加loading
    dispatch(setDataSourceLoadingAction(true))
    const res = await GET_TASKLIST({
      supplierId: getUserId(),
      pageSize: params.pageSize, // 分页尺寸
      pageNo: params.pageNo, // 页码
    })
    dispatch(setDataSourceLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      const resdata = res.data.content
      const count = res.data.totalCount
      const arr = resdata.map((item: any) => ({
        ...item,
        ...{ timeUse: `${(item.timeUse / 1000).toFixed(1)} 秒` },
        ...{ usedTime: `${(item.usedTime / 1000).toFixed(1)} 秒` },
      }))
      dispatch(
        setDataSourceAction({
          dataSource: { data: arr, total: count },
          pageNo: res.data.pageNo,
        }),
      )
    }
  }

  // 刷新
  const onRefresh = (data?: taskcenterState) => {
    getdata(data?.pages ? data : state)
  }

  // 分页
  const onChange = (pageNo: number, pageSize?: number) => {
    dispatch(
      setPagesAction({
        pageNo: pageNo,
        pageSize: pageSize,
      }),
    )
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }

  // 点击下载文件
  const onClickFile = (e: any) => {
    if (e.link) {
      download(`${GetLocalStorage('BASEURL')}${e.link}`)
    }
  }

  // 点击查看详情
  const onClickDetail = (e: any) => {
    history.replace({
      pathname: `${supRoute}/taskdetail`,
      state: {
        init: 'init',
        taskId: e.id,
        fileUrl: e.link,
        fileName: e.fileName,
      },
    })
  }

  const closeTab = () => {
    closeCurrentTab()
  }

  const setChangeSize = (pageNo: number, pageSize: number) => {
    dispatch(
      setPagesAction({
        pageNo: pageNo,
        pageSize: pageSize,
      }),
    )
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }

  return {
    dataSource,
    dataSourceLoading,
    pages,
    onChange,
    onRefresh,
    onClickFile,
    onClickDetail,
    closeTab,
    setChangeSize,
  }
}

export default useTaskCenterHook
import {
  download,
  GetLocalStorage,
  getUserId,
  isResponseCodeSuccess,
} from '../../tools/util'
import { useEffect, useReducer } from 'react'
import { history, useTypedSelector } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { setModuleDataAction } from '../../modules/pagecache'
import { userRouter } from '../../route'
import { GET_TASKLIST } from '../../api/TaskApi'
import { usePageCache } from '../../tools/utilHooks'
import reducer, {
  defaultState,
  taskcenterState,
  reloadStateAction,
  setDataSourceAction,
  setDataSourceLoadingAction,
  setPagesAction,
} from './reducer'

const useTaskCenterHook = () => {
  const [state, dispatch] = useReducer(reducer, defaultState)
  const { dataSource, pages, dataSourceLoading } = state
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const supRoute = userRouter[1].url
  const dispatchRedux = useDispatch()
  const { closeCurrentTab } = usePageCache()

  useEffect(() => {
    const flag = getpagecache()
    if (flag) {
      dispatch(reloadStateAction(flag))
      // 获取缓存的数据后以缓存的页数数据为入参 再次调用接口获取最新数据
      onRefresh(flag)
    } else {
      getdata(state)
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    // 缓存存数据
    const pathName = history.location.pathname
    const action = setModuleDataAction({
      key: pathName,
      data: state,
    })
    dispatchRedux(action)
    // eslint-disable-next-line
  }, [state])

  // 获取数据
  const getpagecache = () => {
    const pathName = history.location.pathname
    const data = pagekey.filter((item) => item.key === pathName)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // 获取列表数据
  const getdata = async (taskcenter: taskcenterState) => {
    // 在saga处理中 获取state
    const params = { ...taskcenter.pages }
    // 添加loading
    dispatch(setDataSourceLoadingAction(true))
    const res = await GET_TASKLIST({
      supplierId: getUserId(),
      pageSize: params.pageSize, // 分页尺寸
      pageNo: params.pageNo, // 页码
    })
    dispatch(setDataSourceLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      const resdata = res.data.content
      const count = res.data.totalCount
      const arr = resdata.map((item: any) => ({
        ...item,
        ...{ timeUse: `${(item.timeUse / 1000).toFixed(1)} 秒` },
        ...{ usedTime: `${(item.usedTime / 1000).toFixed(1)} 秒` },
      }))
      dispatch(
        setDataSourceAction({
          dataSource: { data: arr, total: count },
          pageNo: res.data.pageNo,
        }),
      )
    }
  }

  // 刷新
  const onRefresh = (data?: taskcenterState) => {
    getdata(data?.pages ? data : state)
  }

  // 分页
  const onChange = (pageNo: number, pageSize?: number) => {
    dispatch(
      setPagesAction({
        pageNo: pageNo,
        pageSize: pageSize,
      }),
    )
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }

  // 点击下载文件
  const onClickFile = (e: any) => {
    if (e.link) {
      download(`${GetLocalStorage('BASEURL')}${e.link}`)
    }
  }

  // 点击查看详情
  const onClickDetail = (e: any) => {
    history.replace({
      pathname: `${supRoute}/taskdetail`,
      state: {
        init: 'init',
        taskId: e.id,
        fileUrl: e.link,
        fileName: e.fileName,
      },
    })
  }

  const closeTab = () => {
    closeCurrentTab()
  }

  const setChangeSize = (pageNo: number, pageSize: number) => {
    dispatch(
      setPagesAction({
        pageNo: pageNo,
        pageSize: pageSize,
      }),
    )
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }

  return {
    dataSource,
    dataSourceLoading,
    pages,
    onChange,
    onRefresh,
    onClickFile,
    onClickDetail,
    closeTab,
    setChangeSize,
  }
}

export default useTaskCenterHook
